import axios from "axios";
import { getToken, getCurrentUser } from "@/stores/auth";

// 创建 axios 实例
const http = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 50000, // 请求超时设置
});

// 请求拦截器
http.interceptors.request.use(
  async (config) => {
    // 添加 token
    const token = getToken();
    if (token) {
      config.headers["token"] = token;
    }

    // 自动拼接 line 和 merchantId
    const user = getCurrentUser?.();
    if (user) {
      // body 参数（POST/PUT...）
      if (config.method === "post" || config.method === "put") {
        config.data = {
          ...(config.data || {}),
          line: user.line,
          merchantId: user.merchantId,
        };
      }

      // query 参数（GET/DELETE...）
      if (config.method === "get" || config.method === "delete") {
        config.params = {
          ...(config.params || {}),
          line: user.line,
          merchantId: user.merchantId,
        };
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// 响应拦截器
http.interceptors.response.use(
  (response) => {
    const { data } = response;

    if (data.code === 2) {
      // token 过期，清除并跳转
      localStorage.removeItem("token");
      window.location.href = "/";
      return Promise.reject(new Error(data.message || "登录过期，请重新登录"));
    }

    return data;
  },
  (error) => {
    console.error(error.response || error.message);
    return Promise.reject(error);
  }
);
export default http;
